export default {
  discount_badge: '{{value}} de réduction',
  high_caffeine_warning_required: 'Haute teneur en caféine',
  pfand: 'Incl. {{value}} de consigne',
  alcohol_by_volume_percent: '{{value}} % Vol. Alcool',
};
